<ng-container *ngIf="telemetryStatus$ | async as telemetryStatus; else noDataSkeleton">
  <ng-container *ngIf="blocksToShow$ | async as blocks; else noBlocksSkeleton">

    <ng-container *ngIf="!notDevices">
      <ng-container *ngFor="let block of blocks">
        <ng-container *ngTemplateOutlet="nodeTemplate; context: {
          iconId: block.icon,
          badgeNumber: block.count,
        }">
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template
      #nodeTemplate
      let-iconId="iconId"
      let-badgeNumber="badgeNumber">
      <div
        class="bg-grey-300 bg-opacity-50 p-1 radius-4 fx-center"
        [class.single-node]="blocks.length === 1">
        <div
          class="fx-center"
          matBadgePosition="below after"
          matBadgeColor="accent"
          [matBadge]="badgeNumber">
          <mat-icon [svgIcon]="iconId">
          </mat-icon>
        </div>
      </div>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="{
    value: plantStatus$ | async,
    hasAlert: plantHasAlerts$ | async
  } as status">
    <ng-container *ngIf="!notStatus">
      <div
        *ngIf="status.value?.plantStatus as plantStatus; else noStatusSkeleton"
        id="name"
        class="text-grey-400 text-normal-wrap fx-row fx-align-center fx-gap-3 py-1 px-2 radius-4 tw-font-normal tw-text-sm overflow-x-hidden overflow-y-auto"
        matTooltipPosition="right"
        matTooltipClass="body-2"
        [class.bg-accent-100]="!notDevices"
        [matTooltip]="labels[plantStatus] + (status.hasAlert ? ' - ' + labels['hasAlerts'] : '')">
        <div class="fx-row fx-wrap fx-center fx-justify-start fx-gap-2">
          <mat-icon
            *ngIf="system?.source === 'aws'"
            class="s-7 min-s-7"
            svgIcon="block_verified">
          </mat-icon>
          <div
            *ngIf="status.hasAlert"
            class="tw-p-[2px] radius-4 fx-row fx-gap-1 fx-center fx-wrap bg-red-400">
            <mat-icon class="text-white s-6 min-s-6">
              warning_amber
            </mat-icon>
          </div>
          <div
            class="tw-p-[2px] radius-4 fx-row fx-gap-1 fx-center fx-wrap"
            [ngClass]="{
              'bg-green-400': plantStatus === 'connectedAndUpdated' || plantStatus === 'updated',
              'bg-orange-400': plantStatus === 'notUpdated',
              'bg-red-400': plantStatus === 'disconnected',
            }">
            <mat-icon
              *ngIf="plantStatus === 'connectedAndUpdated' || plantStatus === 'updated'"
              class="text-white s-6 min-s-6">
              sync
            </mat-icon>
            <mat-icon
              *ngIf="plantStatus === 'notUpdated'"
              class="text-white s-6 min-s-6">
              sync_disabled
            </mat-icon>
            <mat-icon
              *ngIf="plantStatus === 'disconnected'"
              class="text-white s-6 min-s-6">
              wifi_off
            </mat-icon>
          </div>
        </div>
        <span
          *ngIf="headerType === 'plantName'; else plantStatusTemplate"
          class="text-uppercase break-word">
          {{ plantName }}
        </span>
        <ng-template #plantStatusTemplate>
          <span
            data-testid="plant-card-status"
            class="text-uppercase tw-font-medium">
            {{ labels[plantStatus] + (status.hasAlert ? ' - ' + labels['hasAlerts'] : '') }}
          </span>
        </ng-template>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #noDataSkeleton>
  <ng-container *ngTemplateOutlet="noStatusSkeleton"></ng-container>
  <ng-container *ngTemplateOutlet="noBlocksSkeleton"></ng-container>
</ng-template>

<ng-template #noStatusSkeleton>
  <ion-skeleton-text
    *ngIf="!notStatus"
    id="name"
    class="min-s-9 h-9 radius-4"
    [animated]="true">
  </ion-skeleton-text>
</ng-template>

<ng-template #noBlocksSkeleton>
  <ng-container *ngIf="!notDevices">
    <ion-skeleton-text
      *ngFor="let _ of deviceCountSkeleton"
      class="min-s-8 s-8 radius-4"
      [animated]="true">
    </ion-skeleton-text>
  </ng-container>
</ng-template>
